import moment from 'moment';

const formatDate = {
  filters: {
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },
  },
};

export default formatDate;



// WEBPACK FOOTER //
// ./src/mixins/formatDate.js